/* State Interface Imports */

import StateInterface from "../state-interface";

/* Home Page Default State Data */

export const homePage: StateInterface["homePage"] = {
	dashboard_stats: {
		total_leads_count: 0,
		new_leads_count: 0,
		published_properties_count: 0,
		loading: true,
	},
	featured_properties: [0, 0, 0, 0],
	hot_properties: [0, 0, 0, 0],
	top_services: [0, 0, 0, 0],
	trending_services: [0, 0, 0, 0],
	top_users: [0, 0, 0, 0],
	trending_users: [0, 0, 0, 0],
	top_business_profiles: [0, 0, 0, 0],
	trending_business_profiles: [0, 0, 0, 0],
	top_developers: [0, 0, 0, 0],
	beegru_top_picks: [0, 0, 0, 0],
	handpicked_apartments: [0, 0, 0, 0],
	top_villas: [0, 0, 0, 0],
	featured_plots: [0, 0, 0, 0],
};
